import React, { useEffect, useState, useCallback } from "react";
import ObjectList from "../Common/ObjectList";
import ObjectListMobile from "../Common/ObjectListMobile";
import http from "../Common/RestAPIHandler";
import Button from "@material-ui/core/Button";
import SnackbarComponent from "../Common/Snackbar";
import { makeStyles } from "@material-ui/core/styles";
import ObjectVersions from "../Common/ObjectVersions";
import { connect } from "react-redux";
import commonConstants from "../Common/CommonConstants";
import HistoryIcon from '@material-ui/icons/History';
import { hasPermission } from "../Common/permission";

const useStyles = makeStyles((theme) => ({
    button: {
      margin: 10,
      borderRadius: 25,
      backgroundColor: theme.colorScheme,
      color: "white",
      textTransform: "capitalize",
      "&:hover": {
        backgroundColor: theme.colorScheme,
        color: "white",
        border: "1px solid white",
      },
    },
    removeButton: {
      margin: 10,
      borderRadius: 25,
      backgroundColor: "red",
      color: "white",
      textTransform: "capitalize",
      "&:hover": {
        backgroundColor: "red",
        color: "white",
        border: "1px solid white",
      },
    },
  }));
  
  
const tableColumns = [
  {
    id: "model",
    label: "MODEL",
    minWidth: 200,
    sortable: true,
  },
  {
    id: "name",
    label: "NAME",
    minWidth: 200,
    sortable: true,
  },
  {
    id: "last_modified_by_name",
    label: "LAST MODIFIED BY",
    minWidth: 200,
    sortable: true,
  },
  {
    id: "deleted_at",
    label: "LAST MODIFIED AT",
    minWidth: 200,
    sortable: true,
  },
  {
    id: "versions",
    label: " ",
    minWidth: 10,
    disableTooltip: true,
    style: commonConstants.cellCursor,
    colored: true,
  },
  {
    id: "actions",
    label: " ",
    minWidth: 200,
    disableTooltip: true,
  },
];

const Archives = (props) => {
  const classes = useStyles();  
  const [data, setData] = useState([]);
  const [loadData, setLoadData] = useState(false);
  const url = `reseller_archives`;
  const [anchorEl, setAnchorEl] = useState(null);
  const [snackBarMessage, setSnackBarMessage] = useState();
  const [versions, setVersions] = useState();
  
  const fetchData = useCallback(() => {
    setLoadData(true);
    http.Get(
      url,
      (data) => {
        data.forEach((archive)=>{
          archive["deleted_at"] = archive["last_modified_time"].split("T")[0];
          archive.actions = <div>
              <Button
                variant="outlined"
                size="small"
                color="primary"
                className={classes.removeButton}
                disabled={!hasPermission(props, ['Remove from Archive'])}
                onClick={()=>{
                  if(window.confirm("Delete permanently?")){
                    http.Delete(
                      url,
                      archive,
                      (res) => {
                        setSnackBarMessage(archive.name + " deleted!");
                        fetchData();
                      },
                      () => {}
                    );
                  }
              }}>Remove</Button>
              <Button
                variant="outlined"
                size="small"
                color="primary"
                className={classes.button}
                disabled={!hasPermission(props, ['Restore from Archive'])}
                onClick={()=>{
                  http.Put(
                      url,
                      archive,
                      (res) => {
                        setSnackBarMessage(res.message);
                        fetchData();
                      },
                      () => {}
                  );
              }}>Restore</Button></div>;

          archive['versions'] = <HistoryIcon
              onClick={(e)=>{
                  setAnchorEl(e.currentTarget);
                  setVersions(null);
                  http.Get(
                    `versions?object_id=${archive.id}&model_name=${archive.model}`,
                    (versions) => {
                      setVersions(versions);
                    },
                    () => {
                      setVersions(null);
                    }
                  );
                  }}/>;

        });
        setData(data);
        setLoadData(false);
      },
      () => {
        setLoadData(false);
      }
    );
  }, [url, classes.removeButton, classes.button, props]);
    
  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <div>
    <SnackbarComponent
      message={snackBarMessage}
      open={Boolean(snackBarMessage)}
      handleSnackBarClose={()=>{setSnackBarMessage(null);}}
      severity={"success"}
    ></SnackbarComponent>
    {anchorEl &&
    <ObjectVersions
      {...props}
      versions={versions}
      fetchData={fetchData}
      anchorEl={anchorEl}
      setAnchorEl={setAnchorEl}
    />}
    {!props.mobile &&
    <ObjectList
      {...props}
      moduleName={
        <div>
          Archives 
          <Button 
              variant="outlined"
              margin="dense"
              size="small"
              className={classes.removeButton}
              disabled={!hasPermission(props, ['Clean Up Archives'])}
              onClick={() => {                
                if(window.confirm("Delete 30 days old data permanently?")){
                  http.Delete(
                    "clean_reseller_archives",
                    {},
                    (res) => {
                      setSnackBarMessage("Data deleted!");
                      fetchData();
                    },
                    () => {}
                  );
                }
              }}
              style={{float:"right"}}>Clean Up</Button>
        </div>
      }
      url={url}
      tableColumns={tableColumns}
      searchFields={["model","name","last_modified_by_name"]}
      order={"desc"}
      orderBy={"deleted_at"}
      data={data}
      fetchData={fetchData}
      pageHeader={(props.company.company_name || "") + " | Archives"}
      loadData={loadData}
      excludeAddButton={true}
    />
    }
    {props.mobile &&
    <ObjectListMobile
      {...props}
      moduleName={"Archives"}
      url={url}
      tableColumns={tableColumns}
      searchFields={["model","name","last_modified_by_name"]}
      order={"desc"}
      orderBy={"last_modified_time"}
      data={data}
      fetchData={fetchData}
      pageHeader={(props.company.company_name || "") + " | Archives"}
      loadData={loadData}
      excludeAddButton={true}
    />
    }
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    company: state.company.company,
  };
};

export default connect(mapStateToProps, null)(Archives);
